module.exports = __webpack_public_path__ + "static/media/NPM.d14c1844.svg";